/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 21
// module chunks = 0